// extracted by mini-css-extract-plugin
module.exports = {"globalFadeInUp":"style__-global-fadeInUp-___FovN2","globalFadeInDown":"style__-global-fadeInDown-___1LdZw"};